import { render } from "./DownloadButton.vue?vue&type=template&id=226ee8de&scoped=true"
import script from "./DownloadButton.vue?vue&type=script&lang=js"
export * from "./DownloadButton.vue?vue&type=script&lang=js"

import "./DownloadButton.vue?vue&type=style&index=0&id=226ee8de&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226ee8de"]])

export default __exports__